import { $WC, $DKD } from '@/conf/common.const.js';
import commonApi from "@/api/common.api.js";
import gripUtil from "@/lib/grip.util.js";

export default {
    state: {
        // 코로나 현황(수치)
        covidState: [],
        // 백신 접종 정보 (최종)
        latestVaccination: {},
    },
    getters: {
        getCovidState(state) {
            return state.covidState;
        },
        getLatestVaccination(state) {
            return state.latestVaccination;
        },
    },
    mutations: {
        COVID_STATE(state, covidState) {
            state.covidState = covidState;
        },
        LATEST_VACCINATION(state, latestVaccination) {
            state.latestVaccination = latestVaccination;
        },
    },
    actions: {
        FETCH_COVID_STATE({commit}) {
            let covidState = [];

            return commonApi.fetchMaxBasdtValDataList($DKD.COVID_STATE)
                .then(res => {
                    let latestCovidState = res.data.data;
                    if(typeof latestCovidState !== $WC.UNDEF && latestCovidState.length > 0) {
                        covidState.push(latestCovidState[0]);

                        let latestCovidDay = latestCovidState[0].basdtVal;
                        let latestDate = gripUtil.stringToDate(latestCovidDay);
                        latestDate.setDate(latestDate.getDate() - 1);
                        let preDay = latestDate.format("yyyyMMdd");

                        let q = "where=basdtVal::" + preDay;
                        return commonApi.fetchRepoDataList($DKD.COVID_STATE, q, false)
                    }
                })
                .then(res => {
                    let preCovidState = res.data.data;
                    if(typeof preCovidState !== $WC.UNDEF && preCovidState.length > 0) {
                        covidState.push(preCovidState[0]);
                    }
                    commit("COVID_STATE", covidState);
                });
        },
        FETCH_LATEST_VACCINATION({commit}) {
            return commonApi.fetchMaxBasdtValDataList($DKD.COVID_VACCINATION)
                .then(res => {
                    let latestVaccinationList = res.data.data;
                    if(typeof latestVaccinationList !== $WC.UNDEF) {
                        commit("LATEST_VACCINATION", latestVaccinationList[0]);
                    }
                });
        },
    }
}
